// combatpro/dice/DiceResult.js
//
// Combat PRO - DiceResult (Stage 36 correction: render inside vi-dice-total).
//
// Renders the current dice result as the legacy vi-dice-total text. In
// battletracker.html the current result was written into the result element as
// "Total: N" (see vi_rollCustomDice writing <div class="vi-dice-result-total">
// Total: ${result.total}</div>, and vi-dice-total being toggled from display
// none to shown to present the total). This component reproduces that textual
// output and is rendered INSIDE the existing vi-dice-total element by DiceView,
// not beside it. There is no parallel result display.
//
// Per the Stage 36 correction (Option 1): show the total, styled like the legacy
// result, matching the source's "Total: N" text. The formula and individual
// rolls are not shown here, matching the legacy vi-dice-total which displayed
// the total.
//
// Presentational only: receives currentDiceResult and renders it. No dice
// mathematics, no state ownership, no history, no storage, no API, no AI, no
// getElementById, no innerHTML, no SVG. The legacy animated polyhedra
// (renderVisualDice / makeDieSVG) remain intentionally deferred.
//
// currentDiceResult shape (built in DiceView): { formula, total, rolls }.
// When null, renders nothing (DiceView keeps vi-dice-total hidden).
//
// No optional chaining. No em dash.

import React from 'react';

function DiceResult(props) {
  var currentDiceResult = props.currentDiceResult;
  if (currentDiceResult === null || currentDiceResult === undefined) {
    return null;
  }

  return (
    <div className="vi-dice-result-total">Total: {currentDiceResult.total}</div>
  );
}

export default DiceResult;
